<div class="search-bar-div">
  <div class="search-input-container modern" [class.has-value]="!!searchValue">
    <span class="leading-icon" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M21 21l-4.2-4.2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
      </svg>
    </span>

    <input
      [(ngModel)]="searchValue"
      (ngModelChange)="onSearchChange()"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      class="search-bar"
      [placeholder]="placeholder"
      type="text"
      autocomplete="off"
      spellcheck="false"
    />

    @if (searchValue) {
      <button
        type="button"
        class="clear-btn"
        (click)="clearSearch()"
        aria-label="Clear search">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    }
  </div>
</div>
